// src/admin/pages/Newsletter.jsx
import React, { useEffect, useState } from "react";
import { T } from "../data/Tokens";

// ─── Inline Icons (same style as AdminSidebar) ─────────────────────────────
function MailIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  );
}
function SearchIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}
function DownloadIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
}
function TrashIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  );
}
function UsersIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}
function TrendIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  );
}
function CalendarIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}
function ChevronLeft(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
}
function ChevronRight(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

const SOURCES = ["All", "Popup", "Footer", "Checkout"];

function timeAgo(dateStr) {
  const diffMs = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

function initials(name) {
  return name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
}

export default function Newsletter() {
  const [subscribers, setSubscribers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const [query, setQuery] = useState("");
  const [source, setSource] = useState("All");
  const [page, setPage] = useState(1);

  // ── Fallback tokens — agar in naamon ke tokens Tokens.js me nahi hain,
  // to bhi UI transparent/tuta hua nahi dikhega. ──
  const bg = T.bg || "#FBF9F4";
  const card = T.card || "#FFFFFF";
  const border = T.border || "#EDE6D8";
  const textPri = T.textPri || "#2A2420";
  const textSec = T.textSec || "#8A7F70";
  const gold = T.gold || "#C69B4C";
  const goldL = T.goldL || "#FBF1DD";
  const goldD = T.goldD || "#8A6A25";
  const danger = T.danger || "#C0574C";
  const dangerL = T.dangerL || "#FBECEA";

  // Search/filter/page badalne par debounce ke saath API call
  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({ search: query, source, page: String(page) });

    const timer = setTimeout(() => {
    fetch(`https://aishcraft.com/backend/newsletter/list.php?${params}`)
        .then((res) => res.json())
        .then((result) => {
          if (result.success) {
            setSubscribers(result.data);
            setTotalPages(result.totalPages);
            setTotal(result.total);
          }
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    }, 300); // typing ke turant baad har keystroke par call na ho, thoda ruk kar

    return () => clearTimeout(timer);
  }, [query, source, page]);

  const weekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
  const todayStart = new Date().setHours(0, 0, 0, 0);

  const stats = [
    { label: "Total subscribers", value: total, icon: <UsersIcon className="w-4 h-4" /> },
    { label: "Joined today", value: subscribers.filter((s) => new Date(s.date).getTime() >= todayStart).length, icon: <CalendarIcon className="w-4 h-4" /> },
    { label: "Joined this week", value: subscribers.filter((s) => new Date(s.date).getTime() >= weekAgo).length, icon: <TrendIcon className="w-4 h-4" /> },
    { label: "From popup", value: subscribers.filter((s) => s.source === "Popup").length, icon: <MailIcon className="w-4 h-4" /> },
  ];

  const handleDelete = async (id) => {
    const prev = subscribers;
    setSubscribers((rows) => rows.filter((r) => r.id !== id));
    try {
    const res = await fetch("https://aishcraft.com/backend/newsletter/delete.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const result = await res.json();
      if (!result.success) setSubscribers(prev);
      else setTotal((t) => Math.max(0, t - 1));
    } catch {
      setSubscribers(prev);
    }
  };

  const handleExport = () => {
    const header = ["Name", "Email", "Phone", "Source", "Date"];
    const lines = subscribers.map((s) => [s.name, s.email, s.phone, s.source, new Date(s.date).toLocaleString("en-IN")]);
    const csv = [header, ...lines].map((row) => row.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "newsletter-subscribers.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen" style={{ background: bg }}>
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-8">
        {/* ── Header ── */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-7">
          <div className="flex items-center gap-3">
            <div
              className="w-11 h-11 rounded-2xl flex items-center justify-center flex-shrink-0"
              style={{ background: goldL, color: goldD }}
            >
              <MailIcon className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-[22px] sm:text-[24px] font-semibold leading-tight" style={{ color: textPri }}>
                Newsletter
              </h1>
              <p className="text-[13px]" style={{ color: textSec }}>
                Everyone who signed up for the 10% off popup and other opt-ins
              </p>
            </div>
          </div>

          <button
            onClick={handleExport}
            className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-[13px] font-semibold transition-opacity hover:opacity-90"
            style={{ background: textPri, color: "#fff" }}
          >
            <DownloadIcon className="w-4 h-4" />
            Export CSV
          </button>
        </div>

        {/* ── Stat cards ── */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-7">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl px-4 py-4"
              style={{ background: card, border: `1px solid ${border}` }}
            >
              <div className="flex items-center justify-between mb-2">
                <span className="text-[11px] font-medium" style={{ color: textSec }}>
                  {s.label}
                </span>
                <span style={{ color: gold }}>{s.icon}</span>
              </div>
              <p className="text-[22px] font-semibold" style={{ color: textPri }}>
                {s.value}
              </p>
            </div>
          ))}
        </div>

        {/* ── Toolbar ── */}
        <div
          className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl px-4 py-3 mb-4"
          style={{ background: card, border: `1px solid ${border}` }}
        >
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <SearchIcon className="w-4 h-4 flex-shrink-0" style={{ color: textSec }} />
            <input
              value={query}
              onChange={(e) => { setQuery(e.target.value); setPage(1); }}
              placeholder="Search by name, email or phone"
              className="w-full text-[13px] outline-none bg-transparent"
              style={{ color: textPri }}
            />
          </div>

          <div className="flex gap-1.5 flex-wrap">
            {SOURCES.map((s) => {
              const isActive = source === s;
              return (
                <button
                  key={s}
                  onClick={() => { setSource(s); setPage(1); }}
                  className="px-3 py-1.5 rounded-lg text-[12px] font-medium transition-colors"
                  style={
                    isActive
                      ? { background: goldL, color: goldD }
                      : { background: "transparent", color: textSec, border: `1px solid ${border}` }
                  }
                >
                  {s}
                </button>
              );
            })}
          </div>
        </div>

        {/* ── Table / Empty / Loading state ── */}
        <div className="rounded-2xl overflow-hidden" style={{ background: card, border: `1px solid ${border}` }}>
          {loading ? (
            <div className="flex flex-col items-center justify-center text-center py-16 px-6">
              <p className="text-[13px]" style={{ color: textSec }}>Loading subscribers…</p>
            </div>
          ) : subscribers.length === 0 ? (
            <div className="flex flex-col items-center justify-center text-center py-16 px-6">
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center mb-3"
                style={{ background: goldL, color: goldD }}
              >
                <MailIcon className="w-6 h-6" />
              </div>
              <p className="text-[15px] font-semibold mb-1" style={{ color: textPri }}>
                No subscribers found
              </p>
              <p className="text-[13px] max-w-xs" style={{ color: textSec }}>
                {query || source !== "All"
                  ? "Try a different search term or filter."
                  : "New signups from the site popup will show up here."}
              </p>
            </div>
          ) : (
            <>
              {/* Desktop table */}
              <div className="hidden md:block overflow-x-auto">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr style={{ borderBottom: `1px solid ${border}` }}>
                      {["Subscriber", "Phone", "Source", "Joined", ""].map((h) => (
                        <th
                          key={h}
                          className="px-5 py-3 text-[11px] font-semibold uppercase tracking-wide"
                          style={{ color: textSec }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {subscribers.map((s) => (
                      <tr key={s.id} style={{ borderBottom: `1px solid ${border}` }}>
                        <td className="px-5 py-3.5">
                          <div className="flex items-center gap-3">
                            <div
                              className="w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-semibold flex-shrink-0"
                              style={{ background: goldL, color: goldD }}
                            >
                              {initials(s.name)}
                            </div>
                            <div className="min-w-0">
                              <p className="text-[13px] font-medium truncate" style={{ color: textPri }}>
                                {s.name}
                              </p>
                              <p className="text-[12px] truncate" style={{ color: textSec }}>
                                {s.email}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td className="px-5 py-3.5 text-[13px]" style={{ color: textPri }}>
                          {s.countryCode ? `${s.countryCode} ` : ""}{s.phone}
                        </td>
                        <td className="px-5 py-3.5">
                          <span
                            className="text-[11px] font-medium px-2.5 py-1 rounded-full"
                            style={{ background: goldL, color: goldD }}
                          >
                            {s.source}
                          </span>
                        </td>
                        <td className="px-5 py-3.5 text-[13px]" style={{ color: textSec }}>
                          {timeAgo(s.date)}
                        </td>
                        <td className="px-5 py-3.5 text-right">
                          <button
                            onClick={() => handleDelete(s.id)}
                            className="p-1.5 rounded-lg transition-colors hover:opacity-80"
                            style={{ color: danger, background: dangerL }}
                            aria-label={`Remove ${s.name}`}
                          >
                            <TrashIcon className="w-3.5 h-3.5" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile cards */}
              <div className="md:hidden divide-y" style={{ borderColor: border }}>
                {subscribers.map((s) => (
                  <div key={s.id} className="px-4 py-3.5" style={{ borderBottom: `1px solid ${border}` }}>
                    <div className="flex items-start justify-between gap-3">
                      <div className="flex items-center gap-2.5 min-w-0">
                        <div
                          className="w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-semibold flex-shrink-0"
                          style={{ background: goldL, color: goldD }}
                        >
                          {initials(s.name)}
                        </div>
                        <div className="min-w-0">
                          <p className="text-[13px] font-medium truncate" style={{ color: textPri }}>{s.name}</p>
                          <p className="text-[12px] truncate" style={{ color: textSec }}>{s.email}</p>
                        </div>
                      </div>
                      <button
                        onClick={() => handleDelete(s.id)}
                        className="p-1.5 rounded-lg flex-shrink-0"
                        style={{ color: danger, background: dangerL }}
                        aria-label={`Remove ${s.name}`}
                      >
                        <TrashIcon className="w-3.5 h-3.5" />
                      </button>
                    </div>
                    <div className="flex items-center justify-between mt-2.5 pl-[42px]">
                      <span className="text-[12px]" style={{ color: textPri }}>
                        {s.countryCode ? `${s.countryCode} ` : ""}{s.phone}
                      </span>
                      <span
                        className="text-[10.5px] font-medium px-2 py-0.5 rounded-full"
                        style={{ background: goldL, color: goldD }}
                      >
                        {s.source}
                      </span>
                    </div>
                    <p className="text-[11px] mt-1 pl-[42px]" style={{ color: textSec }}>{timeAgo(s.date)}</p>
                  </div>
                ))}
              </div>

              {/* ── Pagination ── */}
              <div
                className="flex items-center justify-between px-5 py-3.5"
                style={{ borderTop: `1px solid ${border}` }}
              >
                <p className="text-[12px]" style={{ color: textSec }}>
                  Page {page} of {totalPages} · {total} total
                </p>
                <div className="flex items-center gap-1.5">
                  <button
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    disabled={page === 1}
                    className="w-7 h-7 rounded-lg flex items-center justify-center disabled:opacity-30 transition-opacity"
                    style={{ border: `1px solid ${border}`, color: textPri }}
                  >
                    <ChevronLeft className="w-3.5 h-3.5" />
                  </button>
                  <span className="text-[12px] px-1" style={{ color: textSec }}>
                    {page} / {totalPages}
                  </span>
                  <button
                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                    disabled={page === totalPages}
                    className="w-7 h-7 rounded-lg flex items-center justify-center disabled:opacity-30 transition-opacity"
                    style={{ border: `1px solid ${border}`, color: textPri }}
                  >
                    <ChevronRight className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}